import { pushService } from "@/services/PushService";

/**
 * PushToggle —— 头部菜单中的订阅开关逻辑
 */
export class PushToggle {
  static compiler() {
    up.compiler("[data-push-toggle]", async (el: HTMLElement) => {
      console.debug(
        "[PushToggle] Initializing toggle component for element:",
        el,
      );
      const track = el.querySelector("[data-push-toggle-track]");
      const thumb = el.querySelector("[data-push-toggle-thumb]");

      const updateUI = (optedIn: boolean) => {
        console.debug("[PushToggle] Updating UI, optedIn:", optedIn);
        if (optedIn) {
          track?.classList.remove("bg-border/40");
          track?.classList.add("bg-primary/70");
          thumb?.classList.add("translate-x-4");
        } else {
          track?.classList.add("bg-border/40");
          track?.classList.remove("bg-primary/70");
          thumb?.classList.remove("translate-x-4");
        }
      };

      // 初始状态
      const isSubscribed = await pushService.isSubscribed();
      console.debug("[PushToggle] Initial subscription status:", isSubscribed);
      updateUI(isSubscribed);

      // 监听服务状态变化
      const unbind = pushService.onSubscriptionChange((optedIn) => {
        console.debug(
          "[PushToggle] Service subscription change detected:",
          optedIn,
        );
        updateUI(optedIn);
      });

      // 点击切换
      el.addEventListener("click", async () => {
        const current = await pushService.isSubscribed();
        console.debug("[PushToggle] Toggle clicked, current state:", current);
        if (current) {
          console.debug("[PushToggle] Requesting opt-out...");
          await pushService.optOut();
        } else {
          console.debug("[PushToggle] Requesting opt-in...");
          await pushService.optIn();
        }
      });

      return () => {
        console.debug("[PushToggle] Cleaning up toggle component");
        unbind();
      };
    });
  }
}
